import {Component, Input, OnInit} from '@angular/core';
import {RegisterForm} from '@app/sign-in/register/@form/register-form';

@Component({
  selector: 'app-phone-number-field[registerForm][showValidation]',
  templateUrl: './phone-number-field.component.html',
  styleUrls: ['./phone-number-field.component.scss']
})
export class PhoneNumberFieldComponent implements OnInit {
  @Input() registerForm!: RegisterForm;
  @Input() showValidation!: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  isInvalid(): boolean {
    return this.showValidation && this.registerForm.controls.phoneNumber.invalid;
  }

}
